/**
 * Preferencias de la cajonera de configuración (especificación §4.8; D-14).
 * Se recuerdan por navegador como comodidad; si el storage no está
 * disponible (modo privado, sitio bloqueado), valen los defaults.
 */
export interface PreferenciasSesion {
  mostrarTranscripcion: boolean;
  mostrarAvatar: boolean;
}

export const PREFERENCIAS_POR_DEFECTO: PreferenciasSesion = {
  mostrarTranscripcion: true,
  mostrarAvatar: true,
};

export const PREFERENCIAS_STORAGE_KEY = 'alter_preferencias_sesion';

export function leerPreferencias(storage: Storage | undefined): PreferenciasSesion {
  try {
    const raw = storage?.getItem(PREFERENCIAS_STORAGE_KEY);
    if (!raw) return PREFERENCIAS_POR_DEFECTO;
    const data = JSON.parse(raw) as Partial<Record<keyof PreferenciasSesion, unknown>>;
    return {
      mostrarTranscripcion:
        typeof data.mostrarTranscripcion === 'boolean'
          ? data.mostrarTranscripcion
          : PREFERENCIAS_POR_DEFECTO.mostrarTranscripcion,
      mostrarAvatar:
        typeof data.mostrarAvatar === 'boolean'
          ? data.mostrarAvatar
          : PREFERENCIAS_POR_DEFECTO.mostrarAvatar,
    };
  } catch {
    return PREFERENCIAS_POR_DEFECTO;
  }
}

export function guardarPreferencias(storage: Storage | undefined, p: PreferenciasSesion): void {
  try {
    storage?.setItem(PREFERENCIAS_STORAGE_KEY, JSON.stringify(p));
  } catch {
    // Sin storage: la preferencia dura hasta recargar.
  }
}
